import router from '@/modules/myServices/router'
import { useServiceStore } from '@/modules/myServices/store'
import ServiceApi from '@/modules/myServices/service'

export default {
  router,
  service: new ServiceApi(),
  store: useServiceStore,
}
